// Centralized ZRo Pe brand configuration — update brand identity from one place.
export const BRAND = {
  name: "ZRo Pe",
  tagline: "Simplifying Payments",
  productDescription: "Smart Loan, EMI & Payment Management Platform",
  adminName: "ZRo Pe — Admin",
  support: {
    email: "support@zrope.in",
    whatsapp: "https://wa.me/919999999999",
  },
  colors: {
    navy: "#0B132B",
    navyLight: "#1C2541",
    teal: "#14B8A6",
    tealHover: "#0D9488",
    orange: "#F59E0B",
    success: "#10B981",
    error: "#EF4444",
  },
  assets: {
    logoFull: "/brand/zrope-full.png",
    video: "/brand/zrope-video.mp4",
    logoPrimary: "/brand/zrope-primary.png",
    logoDark: "/brand/zrope-dark.png",
    logoLight: "/brand/zrope-light.png",
    logoSvg: "/brand/zrope-logo.svg",
    mascot: "/brand/zrope-mascot.png",
    icon: "/zrope-icon.png",
    favicon: "/favicon.png",
    appIcon: "/logo512.png",
  },
};
export default BRAND;
